import styled from 'styled-components';
import { Space } from 'antd';

export const MainSpace = styled(Space)``;
